module.exports = __webpack_public_path__ + "img/1fab5.203e37a.svg";